import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { ResendReleasePaymentHoldProvider } from "presentation/store/ResendReleasePaymentHold/ResendReleasePaymentHoldMaintenanceProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { ResendReleasePaymentHoldMaintenance } from "presentation/view/section/ResendReleasePaymentHold/ResendReleasePaymentHoldMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const ResendReleasePaymentHoldCont = () => {
    return <ANAInfoWrapper permission={Permission.RESEND_RELEASE_PAYMENT_HOLD_MAINTENANCE}>
        <MessageBarWrapper>
            <ResendReleasePaymentHoldProvider>
                <GridStyles />
                <ResendReleasePaymentHoldMaintenance />
            </ResendReleasePaymentHoldProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default ResendReleasePaymentHoldCont;